<div class="lead-capture-v2-widget">
  @if (error) {
    <div
      class="error-message"
      role="alert"
      aria-label="lead-capture-error"
    >
      {{ error }}
    </div>
  }

  @if (success && !isBookingEmbed()) {
    <div class="success-message" role="status" aria-label="lead-capture-success">
      <h3>Thank you!</h3>
      <p>Congratulations! You're one step closer to achieving your fitness goals.</p>
    </div>
  }

  @if (loading) {
    <div class="loading" role="status" aria-label="lead-capture-loading">Loading...</div>
  }

  @if (!loading && !(success && !isBookingEmbed())) {
    <div class="lead-capture-v2-survey-wrap">
      <survey [model]="model"></survey>

      @if (!isBookingEmbed() && recaptchaFlow.showV2Challenge()) {
        <div class="widget-submit-section">
          <ufp-widget-recaptcha-v2-section
            [hint]="recaptchaV2Hint"
            (resolved)="onRecaptchaV2Resolved($event)"
            (failed)="onRecaptchaV2Failed()"
          />
        </div>
      }
    </div>
  }

  @if (!isBookingEmbed() && isSubmitting && !recaptchaFlow.showV2Challenge()) {
    <ufp-widget-processing-overlay
      [visible]="true"
      message="Processing your submission..."
    />
  }
</div>
